import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../_shared/hooks';
import { fetchWaterfallRows } from '../api-client';
import type { WaterfallRow } from '../components/waterfallTypes';
import type { StatusMapping } from '../components/types';

export function useLauncherWaterfall(id: string) {
  const { apiFetch } = useApi();

  const query = useQuery<{ rows: WaterfallRow[] | null; status_mapping: StatusMapping | null }>({
    queryKey: ['launcher', 'campaigns', id, 'waterfall'],
    queryFn: () => fetchWaterfallRows(apiFetch, id),
    enabled: !!id,
    gcTime: 0,
  });

  return {
    waterfallRows: query.data?.rows ?? null,
    savedStatusMapping: query.data?.status_mapping ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  } as const;
}
